import { FC } from 'react';
import styled from 'styled-components';

const Container = styled.div(({ theme }) => {
  const { color } = theme;

  return `
    border-radius: 8px;
    padding: 16px;
    border: 1px solid ${color.grayscale[800]};
    color: ${color.grayscale[800]};
    display: flex;
    flex-flow: row nowrap;
  `;
});

const ImageWrapper = styled.div`
  max-width: 28px;
  align-self: center;
  margin-left: 1rem;
`;

const Img = styled.img`
  display: block;
`;

const Statistic = styled.div(({ theme }) => {
  const { color, type } = theme;

  return `
    font-size: ${type.size.max};
    font-weight: ${type.weight.bold};
    color: ${color.grayscale[0]};
  `;
});

const Description = styled.div(({ theme }) => {
  const { type, color } = theme;

  return `
    color: ${color.grayscale[200]};
    font-size: ${type.size.small};
    letter-spacing: -0.01rem;
    text-align: right;
    flex-grow: 1;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: flex-end;
    text-align: right;
    padding-left: 16px;
    line-height: ${type.size.small};

    @media screen and (min-width: 1280px) {
      font-size: ${type.size.regular};
    }
  `;
});

export interface ISmall {
  statistic: number;
  icon?: string;
  description: string;
}

const Small: FC<ISmall> = ({ statistic, icon, description }) => {
  return (
    <Container>
      <Statistic>{statistic}</Statistic>
      {icon && (
        <ImageWrapper>
          <Img src={icon} alt="" />
        </ImageWrapper>
      )}

      <Description>{description}</Description>
    </Container>
  );
};

export default Small;
